import { yupResolver } from '@hookform/resolvers';
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	Box,
	Checkbox,
	FormControlLabel,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
	Switch,
	TextField,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	GetReceiptPrinterDocument,
	useCreateReceiptPrinterMutation,
	useDeleteReceiptPrinterMutation,
	useGetOutletQuery,
	useGetReceiptPrinterQuery,
	useUpdateReceiptPrinterMutation,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { SystemMsgs } from 'helpers/SystemMsg';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { GeneralDeleteDialog } from '../../../../components/Dialog/GeneralDeleteDialog';
import { uppercaseAndRemoveSpace } from 'helpers/hooks/stringNumberFunction/stringConverter';

// const dialogFormFieldsInitialState: DialogFormFields = {
// 	name: '',
// };

interface ReceiptPrinterProps {
	name: string;
	isDefault: boolean;
	// isActive: boolean;
}

export const ReceiptPrinterList = (props: any) => {
	const history = useHistory();
	const { outletID }: any = useParams();
	const location = useLocation();

	const { pathname } = useLocation();

	//
	const { anchorEl, menu, handleClick, handleClose }: any = useMenuOption();

	const [openDialog, setOpenDialog] = useState(false);
	const [openDeleteDialog, setDeleteDialog] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [double, setDouble] = useState(false);

	const { mode } = props;
	const editData = location?.state as any;

	const { setOpenSnackBar, setSnackBarMsg } = useContext(
		SnackBarContext as any,
	);

	const [isDefault, setIsDefault] = useState(menu?.obj?.isDefault);

	useEffect(() => {
		setIsDefault(menu?.obj?.isDefault);
	}, [menu]);
	// const [isActive, setIsActive] = useState(false);

	//QUERIES AND MUTATIONS
	//QUERIES AND MUTATIONS
	//QUERIES AND MUTATIONS

	const {
		called: outletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});
	const outletArray: any[] = getOutlet;

	const {
		data,
		// data: { getReceiptPrinter } = { getReceiptPrinter: [] },
		called: receiptPrinterCalled,
		loading: receiptPrinterLoading,
	} = useGetReceiptPrinterQuery({
		fetchPolicy: 'network-only',
		variables: { outletID: outletID, orderByAsc: 'name' },
	});

	const [
		submitReceiptPrinter,
		{ data: createdReceiptPrinterData, loading: submitReceiptPrinterLoading },
	] = useCreateReceiptPrinterMutation({
		onError: error => {
			console.log('ERROR', error);
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.createNewRecord());

			setTimeout(() => {
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/receipt-printer`,
					state: { success: true, msgMode: 'update' },
				});
			}, 500);
		},
		// fetchPolicy: 'network-only',
	});

	const [
		updateReceiptPrinter,
		{ data: updatedReceiptPrinterData, loading: updateReceiptPrinterLoading },
	] = useUpdateReceiptPrinterMutation({
		onError: error => {
			console.log('ERROR', error);
		},
		onCompleted: data => {
			// history.push(`/subcontract/${consubconId}/vo`);
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.updateRecord());

			setTimeout(() => {
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/receipt-printer`,
					state: { success: true, msgMode: 'update' },
				});
			}, 500);
		},
	});

	const [
		deleteReceiptPrinter,
		{ loading: deleteReceiptPrinterLoading },
	] = useDeleteReceiptPrinterMutation({
		onError: error => {
			// console.log(error, 'error');
			if (error.message.includes('FK_')) {
				setOpenSnackBar(true);
				setSnackBarMsg(SystemMsgs.deleteRecordInUse());
			}
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.deleteRecord());
		},
	});

	//USEFORM

	const existingReceiptPrinterNames = data?.getReceiptPrinter?.map(
		m => m?.name,
	);

	const yupSchema = yup.object().shape({
		name: yup
			.string()
			.required(SystemMsgs.name())
			.trim()
			.typeError('Name cannot be empty')
			.test('name', 'Receipt printer name already exist', value => {
				if (
					(watch('name') !== menu?.obj?.name && isEdit === true) ||
					isEdit === false
				) {
					return !existingReceiptPrinterNames?.includes(value);
				}
				return true;
			}),
	});

	// const testSchema = yup.object().shape({
	// 	name: yup.string().required(SystemMsgs.name()),

	// 	description: yup.string().required(SystemMsgs.description()),
	// 	address: yup
	// 		.string()
	// 		.required(SystemMsgs.address())
	// 		.trim(),
	// });

	const {
		register,
		control,
		handleSubmit,
		watch,
		errors,
		clearErrors,
		formState,
	} = useForm<ReceiptPrinterProps>({
		defaultValues: {
			name: editData?.name,
			isDefault: editData?.isDefault,
			// isActive: editData?.isActive,
		},
		mode: 'onSubmit',
		resolver: yupResolver(yupSchema),
	});

	//ONSUBMIT

	const onSubmit = (data: any) => {
		isEdit === false
			? submitReceiptPrinter({
					variables: {
						input: {
							outletID: outletID,
							name: uppercaseAndRemoveSpace(data.name),
							isDefault:
								isDefault === undefined || isDefault === false ? false : true,
							// isActive: data.isActive,
						},
					},
					refetchQueries: [
						{
							query: GetReceiptPrinterDocument,
							variables: { outletID, orderByAsc: 'name' },
						},
					],
			  })
			: updateReceiptPrinter({
					variables: {
						input: {
							ID: menu?.obj?.ID,
							outletID: outletID,
							name: uppercaseAndRemoveSpace(data.name),
							isDefault:
								isDefault === undefined || isDefault === false ? false : true,
							// isActive: data.isActive,
						},
					},
					refetchQueries: [
						{
							query: GetReceiptPrinterDocument,
							variables: { outletID, orderByAsc: 'name' },
						},
					],
			  });
		setOpenDialog(false);
		setIsDefault(false);
		clearErrors();
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
		setIsDefault(false);
		clearErrors();
	};

	// return <>qro</>;

	return (
		<>
			{updateReceiptPrinterLoading && <Loading />}
			{receiptPrinterLoading && <Loading />}
			{outletLoading && <Loading />}
			{submitReceiptPrinterLoading && <Loading />}
			{deleteReceiptPrinterLoading && <Loading />}

			<MainHeader
				onClick={() =>
					history.push({
						pathname: `/menu/outlet-app/outlet-setting/${outletID}`,
					})
				}
				mainBtn="back"
				smTitle={`Outlet App`}
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Outlet Settings' },
					{ name: 'Receipt Printer', current: true },
				]}
			/>
			<ContentWrapper float>
				<List className="core-list">
					{!receiptPrinterLoading &&
					!outletLoading &&
					// (getReceiptPrinter === undefined ||
					data?.getReceiptPrinter?.length === 0 ? (
						<EmptyList
							title="No Record found"
							subtitle="Please add receipt printer to continue"
						/>
					) : (
						data?.getReceiptPrinter
							// ?.sort((a, b) => {
							// 	return a.name.localeCompare(b.name);
							// })
							?.map((el, index) => (
								<ListItem>
									<ListItemText
										primary={
											<>
												<span className="smTitle flex-space">{el?.name}</span>
												<span className="xxTitle highlight-text text-separator"></span>
											</>
										}
										secondary={
											<>
												<span className="desc">
													<span className="desc">
														{el?.isDefault ? 'Default' : null}
													</span>
												</span>
											</>
										}
									/>

									<ListItemSecondaryAction>
										<IconButton
											edge="end"
											aria-label="more"
											aria-controls="menu-list"
											aria-haspopup="true"
											onClick={e => handleClick(e, el?.ID, index, el)}
										>
											<MoreVert />
										</IconButton>
									</ListItemSecondaryAction>
								</ListItem>
							))
					)}
				</List>
				<Menu
					id="menu-list"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
					onClick={handleClose}
				>
					<MenuItem
						onClick={() => {
							setOpenDialog(true);
							setIsEdit(true);
							setDouble(false);
						}}
					>
						<span className="">Edit</span>
					</MenuItem>
					<MenuItem
						onClick={() => {
							setDeleteDialog(true);
						}}
					>
						<span className="">Delete</span>
					</MenuItem>
				</Menu>
			</ContentWrapper>
			<form onSubmit={handleSubmit(onSubmit)} id="submit-form">
				<Box mt={1}>
					<CommonDialog
						fullWidth={true}
						open={openDialog}
						onClose={() => handleCloseDialog()}
						sections={{
							header: {
								dynamic: (
									<div className="">
										<div className="dialog-dynamic-content">
											<div className="session">
												<div className="title ">{`${
													isEdit ? 'Edit' : 'New'
												} Receipt Printer`}</div>
											</div>
										</div>
									</div>
								),
							},
							body: () => (
								<>
									<div className="content-container">
										{/* <FormControlLabel
											control={
												<Checkbox
													checked={isActive}
													onChange={e => {
														setIsActive(e.target.checked);
													}}
													name="active"
													color="primary"
												/>
											}
											label="Active"
										/> */}
										<Controller
											as={TextField}
											name="name"
											label="Receipt Printer Name"
											autoComplete="off"
											multiline={true}
											defaultValue={isEdit ? menu?.obj?.name : null}
											fullWidth
											ref={register}
											control={control}
											required
											helperText={errors?.name?.message}
											error={errors?.name ? true : false}
											onInput={() => {
												setDouble(false);
											}}
										/>

										<div
											className="full"
											style={{
												justifyContent: 'space-between',
												display: 'flex',
											}}
										>
											<span style={{ marginTop: '7px' }} className="flex-space">
												Set Default
											</span>

											<Switch
												name="isDefault"
												checked={isDefault}
												// defaultChecked={menu?.obj?.isDefault}
												onChange={e => {
													setIsDefault(e.target.checked);
												}}
												color="primary"
											/>
										</div>
									</div>
								</>
							),
							footer: {
								actions: [
									{
										displayText: 'Cancel',
										props: {
											onClick: () => {
												handleCloseDialog();
											},
											variant: 'contained',
											color: 'primary',
										},
									},
									{
										displayText: 'Confirm',
										props: {
											variant: 'contained',
											form: 'submit-form',
											color: 'primary',
											disabled: double,

											onClick: () => {
												if (errors?.name ? false : true) {
													handleSubmit(onSubmit)();
													setDouble(true);
												}
											},
										},
									},
								],
							},
						}}
					/>
				</Box>
			</form>

			<GeneralDeleteDialog
				ID={menu?.ID}
				refetchID={{ outletID: outletID, orderByAsc: 'name' }}
				openDialog={openDeleteDialog}
				setOpenDialog={setDeleteDialog}
				dialogName={menu?.obj?.name}
				deleteMutation={deleteReceiptPrinter}
				refetchDocument={GetReceiptPrinterDocument}
			/>

			<FloatButton
				onClick={() => {
					setOpenDialog(true);
					setIsEdit(false);
					setDouble(false);
				}}
			/>
		</>
	);
};
